export const teamsPageStateKey = 'teams-page';

export interface TeamsState {
	error: string | null;
	loading: boolean;
	currentPage: number;
	pageSize: number;
	filters: any[];
	sort: any[];
	usersList: any[];
	total: number;
}

export const initialState: TeamsState = {
	error: null,
	loading: false,
	currentPage: 0,
	pageSize: 25,
	filters: [],
	sort: [],
	usersList: [],
	total: 0,
};
